import React, { useEffect, useState } from "react";
import { Button, Form, Grid, Icon, Modal, TextArea } from "semantic-ui-react";
import Files from "react-files";
import { connect, useDispatch } from "react-redux";
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import PlayersDropdown from "../../athletes/PlayersDropdown";
import { newTestimonial } from "../../../store/actions/testimonialActions";

const Add = (props) => {
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(null);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [fileURL, setFileURL] = useState(null);
  const [player, setPlayer] = useState(null);
  const dispatch = useDispatch();
  // close function
  const handleClose = () => {
    setError(null);
    setInfo(null);
    setFile(null);
    setFileName(null);
    setFileURL(null);
    setPlayer(null);
    props.close();
  };
  // Submit Function
  const handleSubmit = () => {
    if (!error) {
      const toFirestore = {
        id: props.open?.id,
        content: info ? info : props.open?.content,
        player: player ? player : props.open?.player,
        file,
        fileName: fileName ? fileName : props.open?.fileName,
      };
      dispatch(newTestimonial(toFirestore));
    } else setError("All fields are required");
  };

  // Automatically Closes After Adding to Database
  useEffect(() => {
    if (props.newStwAdd) {
      handleClose();
    }
  }, [props.newStwAdd]);

  // Automatically Clears Error if all data are there
  useEffect(() => {
    if (player && info && error) {
      setError(null);
    }
  }, [player, info, error]);

  return (
    <Modal
      size="small"
      className="cu-event-modal"
      onClose={handleClose}
      open={props.open}
    >
      <Modal.Content scrolling>
        <div className="AdminTopButtonsProgressContainer">
          <div className="AdminTopButtonsContainer">
            <Button
              floated="left"
              circular
              icon="close"
              onClick={handleClose}
            />

            <Button
              disabled={error}
              loading={props.newStwAdding}
              floated="right"
              positive
              name="saveButton"
              content="Save"
              labelPosition="right"
              icon="checkmark"
              onClick={handleSubmit}
            />
          </div>
          {error && <p style={{ color: "#800000" }}>{error}</p>}
          {props.newStwError && (
            <p style={{ color: "#800000" }}>{props.newStwError.message}</p>
          )}
        </div>
        <Form>
          <div className="AdminFormEventContainer add-partner-modal">
            <h3>Edit Testimonial</h3>
            <Grid divided="vertically">
              {props.open?.image && !file && (
                <Grid.Row stackable="true" columns={1}>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <div
                      className="image-preview-data"
                      style={{ background: `url(${props.open?.image})` }}
                    />
                    {props.open?.fileName && (
                      <p className="note cu-center">{props.open?.fileName}</p>
                    )}
                  </Grid.Column>
                </Grid.Row>
              )}
              {file && (
                <Grid.Row stackable="true" columns={1}>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <div
                      className="image-preview-data"
                      style={{ background: `url(${fileURL})` }}
                    />
                    {fileName && <p className="note cu-center">{fileName}</p>}
                  </Grid.Column>
                </Grid.Row>
              )}
              <Grid.Row stackable="true">
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Form.Field required>
                    <label>Player's Name</label>
                    <PlayersDropdown
                      defaultValue={props.open?.player}
                      testimonial
                      name="Testimonial Player"
                      onChange={(e, data) => setPlayer(data.value)}
                      placeholder="Player's Name"
                    />
                  </Form.Field>
                  <Form.Field required>
                    <label>Add Content</label>
                    <TextArea
                      defaultValue={props.open?.content}
                      className="cu-textarea"
                      placeholder="Tell us more"
                      onChange={(e) => {
                        setInfo(e.target.value);
                        setError(null);
                      }}
                    />
                  </Form.Field>
                </Grid.Column>

                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Files
                    className="files-dropzone"
                    accepts={["image/*", ".heic"]}
                    clickable
                    multiple={false}
                    onChange={(file) => {
                      setFile(file[0]);
                      setFileName(file[0].name);
                      setError(null);
                      setFileURL(file[0].preview.url);
                    }}
                  >
                    <label className="btn-cu ui green button btn-cu w-100">
                      <Icon name="upload" />
                      Upload Image
                    </label>
                  </Files>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Form>
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  let schools = [];
  const schoolsData = state.firestore.ordered.schools;
  if (schoolsData && schoolsData.length > 0) {
    schoolsData.forEach((e, i) => {
      let data = {};
      data.key = i;
      data.text = e.name;
      data.value = e.id;
      schools.push(data);
    });
  }

  return {
    schoolsOptions: schools,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    newStwAdd: state.testimonial.Add,
    newStwError: state.testimonial.AddError,
    newStwAdding: state.testimonial.Adding,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "partners",
      },
      {
        collection: "partnersOrder",
      },
      {
        collection: "schools",
        orderBy: ["name", "asc"],
      },
    ];
    return firestoreArray;
  })
)(Add);
